<template>
  <div class="home-wrapper"> 
    <div class="home-inner">
      <div class="banner">
        <img src="../assets/img/banner.jpg" alt="">
      </div>
      <div class="main">
        <div class="home-title">
          投票榜单
        </div>
        <div class="home-item" v-for="item in bdlist" :key="item.id" @click="goList(item.id)">
          <div class="bg">立即投票</div>
          <span>{{item.title}}</span>
        </div>
      </div>
          <div class="rule list-rule">
            <div class="rule-inner">
                <h4 class="rule-title">活动规则</h4>
                <div class="rule-content">
                  <p class="rule-item"><b>活动主题：</b><br><span>2019名人堂评选活动</span></p>
                  <p class="rule-item"><b>投票方式:</b><br><span>下载封面新闻客户端，进入【我的】-【封蜜club】 “2019名人堂”进行投票</span></p>
                  <p class="rule-item"><span>每个用户每天可给每个榜单投10票。</span></p>
                  <p class="rule-item"><span>禁止刷票等行为，后台发现后立即取消资格。</span></p>
                  <p class="rule-item"><span>读者投票的评选权重占30%，专家评审的评选权重占70%。专家评审有一票否决权</span></p>
                </div>
            </div>            
        </div>
    </div> 
    <base-component :baseData="baseData" v-if="baseData"></base-component>    
  </div>
</template>

<script>

import BaseComponent from '@/components/Base'
import {mapState} from 'vuex'

export default {
  name: 'home',
  data() {
    return {
      
    }
  },
  props: ['baseData'],
  components: {
    BaseComponent
  },
  computed: {
    ...mapState(['bdlist'])
  },
  methods: {
    goList(id) {
      this.$router.push(`/list?id=${id}`);
    }
  }
}
</script>

<style lang="less" scoped>
  .home-wrapper {
    background: #fff;
    position: relative;
  }
  .home-inner {
    position: relative;
    z-index: 1;
  }
  .banner {
    height: 7.5rem;
  }
  .main {
    padding: .533333rem .277778rem;
    text-align: center;
  }
  .home-title {
    font-weight: 700;
    font-size: .574074rem;
    color: #383838;
    line-height: 1.3;
    text-align: center;
    padding-bottom: .185185rem;
    position: relative;
    letter-spacing: .1rem;
    margin: 0 0 .814815rem;
  }
  .home-title::after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -.296296rem;
    bottom: 0;
    width: .592593rem;
    height: .111111rem;
    background-color: #db332a;
  }
  .home-item {
    margin-bottom: .740741rem;
    position: relative;
    .bg {
      position: relative;
      height: 3rem;
      background: #cb372b;
      border-radius: 0.2rem;
      color: #fff;
      font-size: 0.7rem;
      text-align: center;
      font-weight: bold;
      box-sizing: border-box;
      padding-top: 0.75rem;
      border: 2px solid #f5df78;
      letter-spacing: 0.2rem;
    }
    span {
      display: block;
      font-size: .43rem;
      font-weight: 700;
      line-height: 1.3;
      background-color: #fff;
      box-shadow: 0 0.138889rem 0.462963rem #e5dcdc;
      padding: .481481rem 0;
      text-align: center;
      margin: -.777778rem .277778rem 0;
      position: relative;
      border-radius: .15rem;
    }
  }
</style>
